/**
 * Our place categories (src/config/placeTaxonomy.js) in the type vocabulary the
 * client's pin glyphs, icons and category labels read ('museum', 'park',
 * 'tourist_attraction'), for spine places that carry a category_id instead of
 * Google types. Whole families map unless a subcategory needs its own glyph;
 * anything else is a sight ('tourist_attraction').
 *
 * One table for both sides: the client pins Discover Sights with it
 * (categoryUtils.typesForSpineCategory) and the server labels a saved spine
 * place with it (savedItemsQueryService.spineCategoryTypeSql), so a sight
 * saved from Discover keeps the pin it had there.
 *
 * Not placeSearchService's CATEGORY_TYPE_MAPPING (search categories → the
 * Google types a search asks for): this only picks a glyph and label for a
 * place we already hold.
 *
 * CommonJS so the server can require it; the frontend imports it with ESM
 * `import { … }`. Keep it plain literals (see holidayCalendar.js: webpack's
 * export inference bails on spread or Object.entries at module scope).
 */

const SPINE_SUBCATEGORY_TYPES = {
  'culture.gallery': 'art_gallery',
  'culture.library': 'library',
  'family.zoo': 'zoo',
  'family.theme_park': 'amusement_park',
  'family.ride': 'amusement_park',
  'family.water_park': 'amusement_park',
  'shows.cinema': 'movie_theater',
  'shopping.mall': 'shopping_mall'
};

const SPINE_FAMILY_TYPES = {
  culture: 'museum',
  outdoors: 'park',
  family: 'park',
  shopping: 'store'
};

module.exports = {
  SPINE_SUBCATEGORY_TYPES,
  SPINE_FAMILY_TYPES
};
